/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { OperatingModeDto } from '../models';
/**
 * OperatingModeApi - axios parameter creator
 * @export
 */
export const OperatingModeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {OperatingModeDto} operatingModeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchOperatingMode: async (businessId: number, operatingModeDto: OperatingModeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('switchOperatingMode', 'businessId', businessId)
            // verify required parameter 'operatingModeDto' is not null or undefined
            assertParamExists('switchOperatingMode', 'operatingModeDto', operatingModeDto)
            const localVarPath = `/api/v1/businesses/{businessId}/operating-mode`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operatingModeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatingModeApi - functional programming interface
 * @export
 */
export const OperatingModeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatingModeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {OperatingModeDto} operatingModeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchOperatingMode(businessId: number, operatingModeDto: OperatingModeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatingModeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchOperatingMode(businessId, operatingModeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatingModeApi.switchOperatingMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperatingModeApi - factory interface
 * @export
 */
export const OperatingModeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatingModeApiFp(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {OperatingModeDto} operatingModeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchOperatingMode(businessId: number, operatingModeDto: OperatingModeDto, options?: RawAxiosRequestConfig): AxiosPromise<OperatingModeDto> {
            return localVarFp.switchOperatingMode(businessId, operatingModeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperatingModeApi - object-oriented interface
 * @export
 * @class OperatingModeApi
 * @extends {BaseAPI}
 */
export class OperatingModeApi extends BaseAPI {
    /**
     * 
     * @param {number} businessId 
     * @param {OperatingModeDto} operatingModeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatingModeApi
     */
    public switchOperatingMode(businessId: number, operatingModeDto: OperatingModeDto, options?: RawAxiosRequestConfig) {
        return OperatingModeApiFp(this.configuration).switchOperatingMode(businessId, operatingModeDto, options).then((request) => request(this.axios, this.basePath));
    }
}

